/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SourcingSearchFreelancerType = {
    Registered: 'REGISTERED',
    Unregistered: 'UNREGISTERED'
} as const;
export type SourcingSearchFreelancerType = typeof SourcingSearchFreelancerType[keyof typeof SourcingSearchFreelancerType];


export function instanceOfSourcingSearchFreelancerType(value: any): boolean {
    for (const key in SourcingSearchFreelancerType) {
        if (Object.prototype.hasOwnProperty.call(SourcingSearchFreelancerType, key)) {
            // @ts-ignore
            if (SourcingSearchFreelancerType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SourcingSearchFreelancerTypeFromJSON(json: any): SourcingSearchFreelancerType {
    return SourcingSearchFreelancerTypeFromJSONTyped(json, false);
}

export function SourcingSearchFreelancerTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchFreelancerType {
    return json as SourcingSearchFreelancerType;
}

export function SourcingSearchFreelancerTypeToJSON(value?: SourcingSearchFreelancerType | null): any {
    return value as any;
}

